import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#252627",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M6.667 14.167 10 17.5m0 0 3.333-3.333M10 17.5V10m6.666 3.952a4.583 4.583 0 0 0-2.917-8.12.52.52 0 0 1-.444-.25 6.25 6.25 0 1 0-9.816 7.58"
    }, null, -1)
  ])))
}
export default { render: render }